/**
 * NeedLoginScoff
 * 
 * @Author: Focci
 * @Date: 2023-12-02 12:18:27
 * @Last Modified by: Focci
 * @Last Modified time: 2023-12-02 12:18:27
 */

import PropTypes from 'prop-types'
import useLogin from '@hook/useLogin'
import { Waypoint } from 'react-waypoint'
import PropertyItemScoff from './PropertyItemScoff'
import NeedLogin from '../common/NeedLogin'

export default function NeedLoginScoff({
  children,
  ready,
  needLoginProps,
  onEnter = () => {},
  ...props
}) {
  const { isLogin } = useLogin()
  return (
    <PropertyItemScoff {...props}>
      {!isLogin && (
        <NeedLogin {...needLoginProps} />
      )}
      {isLogin && (
        <Waypoint onEnter={onEnter}>
          <div>
            {!ready && <NeedLogin {...needLoginProps} loading />}
            {ready && children}
          </div>
        </Waypoint>
      )}
    </PropertyItemScoff>
  )
}

NeedLoginScoff.propTypes = {
  children: PropTypes.node,
  ready: PropTypes.bool,
  needLoginProps: PropTypes.object,
}
